import { createWorld } from 'koota';

const world = createWorld();

export { world };
